/* ÜRETİLMİŞ DOSYA — ELLE DÜZENLEMEYİN.
   Kaynak: ris-api/RIS.UI/src/shared/template-builder
   Güncelleme: ris-api/scripts/sync-template-builder.sh */

import { Button, Checkbox, Col, Input, Row, Select, Space, Tabs, Empty } from 'antd'
import BlockList from './BlockList'

const VARIANTS = (t) => [
    { key: 'default', label: t('Varsayılan') },
    { key: 'first', label: t('İlk Sayfa') },
    { key: 'even', label: t('Çift Sayfa') },
]

/**
 * Üstbilgi/altbilgi düzenleyici.
 *
 * Üç varyant da destekleniyor (default / first / even) çünkü gerçek onam formlarının tamamı üçünü de
 * kullanıyor. Bir varyant tanımlanmadıkça belgeye eklenmez.
 */
export default function HeaderFooterEditor({
    area,
    onChange,
    isFooter = false,
    language,
    languages,
    placeholders,
    apiKey,
    registerInsert,
    t = (x) => x,
}) {
    const current = area || {}
    const pageNumber = current.pageNumber || { enabled: false, format: '{PAGE} / {PAGES}', align: 'center' }

    const setVariant = (key, value) => onChange({ ...current, [key]: value })

    return (
        <>
            {isFooter && (
                <Row gutter={8} align="middle" style={{ marginBottom: 8 }}>
                    <Col>
                        <Checkbox
                            checked={!!pageNumber.enabled}
                            onChange={(e) =>
                                onChange({ ...current, pageNumber: { ...pageNumber, enabled: e.target.checked } })
                            }
                        >
                            {t('Sayfa numarası')}
                        </Checkbox>
                    </Col>
                    {pageNumber.enabled && (
                        <>
                            <Col span={7}>
                                <Input
                                    size="small"
                                    addonBefore={t('Biçim')}
                                    value={pageNumber.format}
                                    onChange={(e) =>
                                        onChange({ ...current, pageNumber: { ...pageNumber, format: e.target.value } })
                                    }
                                />
                            </Col>
                            <Col span={5}>
                                <Select
                                    size="small"
                                    style={{ width: '100%' }}
                                    value={pageNumber.align || 'center'}
                                    onChange={(align) => onChange({ ...current, pageNumber: { ...pageNumber, align } })}
                                    options={[
                                        { value: 'left', label: t('Sol') },
                                        { value: 'center', label: t('Orta') },
                                        { value: 'right', label: t('Sağ') },
                                    ]}
                                />
                            </Col>
                        </>
                    )}
                </Row>
            )}

            <Tabs
                size="small"
                items={VARIANTS(t).map(({ key, label }) => ({
                    key,
                    label,
                    children: current[key] ? (
                        <>
                            <Space style={{ marginBottom: 8 }}>
                                <Button size="small" danger onClick={() => setVariant(key, null)}>
                                    {t('Bu varyantı kaldır')}
                                </Button>
                            </Space>
                            <BlockList
                                blocks={current[key].blocks || []}
                                language={language}
                                languages={languages}
                                placeholders={placeholders}
                                apiKey={apiKey}
                                registerInsert={registerInsert}
                                t={t}
                                depth={1}
                                onChange={(blocks) => setVariant(key, { ...current[key], blocks })}
                            />
                        </>
                    ) : (
                        <Empty
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                            description={t('Bu varyant tanımlı değil')}
                        >
                            <Button size="small" type="primary" onClick={() => setVariant(key, { blocks: [] })}>
                                {t('Tanımla')}
                            </Button>
                        </Empty>
                    ),
                }))}
            />
        </>
    )
}